// extracted by mini-css-extract-plugin
export default {"box":"styles_box__yScft","boxTitle":"styles_boxTitle__e7TR2","border":"styles_border__hmXJ2","isChange":"styles_isChange__E+dCw","isNotChange":"styles_isNotChange__6qkht"};